import './AboutPageOurStory.scss';
import twoBuddiesImg from '../../../assets/images/about_us_page/two_buddies.png';

const AboutPageOurStory = () => {
  return (
    <section className="about-our-story">
      <div className="story-container">
        {/* Header */}
        <div className="story-header">
          <div className="story-tag">
            The Origin Story
          </div>
          <h2 className="story-title">
            Two Buddies. One Shared Pain.
          </h2>
          <h3 className="story-subtitle">
            Infinite Determination.
          </h3>
        </div>

        <div className="story-content">
          {/* Left Side - Story Text */}
          <div className="story-text-section">
            <div className="story-chapters">
              {/* Chapter 1 */}
              <div className="chapter">
                <div className="chapter-header">
                  <div className="chapter-tag">Chapter 1</div>
                  <h4 className="chapter-title">The Discovery</h4>
                </div>
                <div className="chapter-content">
                  <p>
                    Two buddies from <strong>Delhi Technological University</strong> (formerly Delhi College of Engineering) crossed paths and discovered a shared concern that many peers were struggling to find freelance opportunities either on existing platforms or offline.
                  </p>
                </div>
              </div>

              {/* Chapter 2 */}
              <div className="chapter">
                <div className="chapter-header">
                  <div className="chapter-tag">Chapter 2</div>
                  <h4 className="chapter-title">The Realization</h4>
                </div>
                <div className="chapter-content">
                  <p>
                    Soon they realized that this was <span className="highlight-text">the problem of the massive scale</span>. Talented developers, designers, and creators were drowning in a sea of global competition, waiting months for their first opportunity.
                  </p>
                </div>
              </div>

              {/* Chapter 3 */}
              <div className="chapter">
                <div className="chapter-header">
                  <div className="chapter-tag">Chapter 3</div>
                  <h4 className="chapter-title">The Revolution</h4>
                </div>
                <div className="chapter-content">
                  <p>
                    Fueled by their passion for technology and entrepreneurship, they decided to join forces and build a startup. <strong>We felt the pain current platforms were having very deeply</strong>. The lack of knowledge around freelancing, the lack of proper resources. We felt it all.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Team Image */}
          <div className="story-image-section">
            <div className="image-card">
              <div className="image-placeholder">
                {/* Placeholder for team image - you can replace with actual image */}
                <div className="team-image-placeholder">
                  <div className="placeholder-content">
                    <img style={{height:'100%', width:'100%'}} src={twoBuddiesImg} alt='threeBuddiesImg'>
                    </img>
                  </div>
                </div>
              </div>
              <div className="image-badge">
                <div className="badge-content">
                  <span className="badge-text">DTU</span>
                  <span className="badge-subtext">Alumni</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPageOurStory;
